import React, { useEffect } from 'react';
import {
  Chevron,
  CurrentPrice,
  OldPrice,
  OrderSummary,
  OrderSummaryText,
  OrderSummaryTextCol,
  PaymentAmountCol,
  PaymentSummaryWrapper,
  TogglePaymentSummaryWrapper,
} from './MobilePaymentSummary.style';

import { observer } from 'mobx-react-lite';
import chevronDown from '../../../assets/chevronDown.svg';
import chevronUp from '../../../assets/chevronUp.svg';
import { useMst } from '../../../models/rootModel';
import { calculateAmountWithDiscount, formatAmount } from '../../../utils/price/price.utils';
import { PaymentSummary, PaymentSummaryProps } from './PaymentSummary';
import { SuggestPlan } from './SuggestPlan';

interface PaymentSummaryToggleProps extends PaymentSummaryProps {
  planPriceWithoutBargainShort: number;
  ShowOffer?: boolean;
}

export const MobilePaymentSummary: React.FC<PaymentSummaryToggleProps> = observer((props) => {
  const {
    UserPayment: {
      paymentComponentMetadata: { showMobilePaymentSummary, toggleShowMobilePaymentSummary, ShowMobilePaymentSummary },
    },
  } = useMst();
  const { ShowOffer = false } = props;
  const toggle = () => {
    toggleShowMobilePaymentSummary();
  };

  useEffect(() => {
    if (props.appliedDiscount) ShowMobilePaymentSummary();
    // eslint-disable-next-line
  }, [props.appliedDiscount]);

  const priceWithDiscount = calculateAmountWithDiscount(props.planPriceInCents, props.appliedDiscount);
  const totalPriceFormatted = formatAmount(priceWithDiscount);

  return (
    <TogglePaymentSummaryWrapper>
      <OrderSummary onClick={toggle}>
        <OrderSummaryTextCol>
          <OrderSummaryText>{showMobilePaymentSummary ? 'Hide order summary' : 'Order summary'}</OrderSummaryText>
          <Chevron src={showMobilePaymentSummary ? chevronUp : chevronDown} />
        </OrderSummaryTextCol>
        <PaymentAmountCol>
          {props.planPriceWithoutBargainShort > 0 && (
            <OldPrice>
              {props.planCurrency}
              {props.planPriceWithoutBargainShort}
            </OldPrice>
          )}
          <CurrentPrice>
            {props.planCurrency}
            {totalPriceFormatted}
          </CurrentPrice>
        </PaymentAmountCol>
      </OrderSummary>
      <PaymentSummaryWrapper showChildren={showMobilePaymentSummary} withYearlySuggest={ShowOffer}>
        <PaymentSummary
          planName={props.planName}
          planPriceInCents={props.planPriceInCents}
          planWeeklyPriceShort={props.planWeeklyPriceShort}
          planMonthlyPriceShort={props.planMonthlyPriceShort}
          appliedDiscount={props.appliedDiscount}
          planCurrency={props.planCurrency}
          showCouponForm={props.showCouponForm}
        />
        {ShowOffer && <SuggestPlan interval="year" />}
      </PaymentSummaryWrapper>
    </TogglePaymentSummaryWrapper>
  );
});
